import { Component, OnInit, Input } from '@angular/core';
import { faCaretUp } from "@fortawesome/free-solid-svg-icons";

@Component({
  selector: 'app-hint',
  templateUrl: './hint.component.html',
  styleUrls: ['./hint.component.scss']
})
export class HintComponent implements OnInit {
  @Input() arrowSide: string;
  @Input() textContent: string;

  faCaretUp = faCaretUp;

  constructor() { }

  ngOnInit() {
  }

}
